import { useEffect, useState } from 'react'

const useTenantsQuery = (setShowDropdownFilter, tenantsIncluded) => {
  const [tenants, setTenants] = useState(tenantsIncluded || [])
  const [query, setQuery] = useState('')

  const dropdownFilterHandler = () => setShowDropdownFilter(prev => !prev)
  const handleInputChange = ({ target }) => setQuery(target.value)
  const handleKeyChange = ({ code }) =>
    code === 'Backspace' && setTenants(tenantsIncluded || [])

  useEffect(() => {
    setTenants(tenantsIncluded || [])
    setTenants(
      tenants?.filter(({ attributes }) =>
        attributes.name.toLowerCase().includes(query.toLocaleLowerCase())
      )
    )
    if (query === ' ' || query === '') setTenants(tenantsIncluded || [])
    // eslint-disable-next-line
  }, [query, tenantsIncluded])

  return {
    dropdownFilterHandler,
    handleInputChange,
    handleKeyChange,
    tenants,
    query,
  }
}

export default useTenantsQuery
